const ShopSuey = {
  noScroll(active = true) {
    const body = document.querySelector("body");
    if (active) {
      body.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
    }
  },
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  },
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  },
  setCSSVariable(variable, value) {
    document.documentElement.style.setProperty(variable, value);
  },
  getCSSVariable(variable) {
    getComputedStyle(document.documentElement).getPropertyValue(variable);
  },
  makeSticky(selector, options = {}) {
    const element = document.querySelector(selector);
    if (!element) return;

    const {
      top = 0,
      zIndex = 10,
      backgroundColor = "transparent",
      padding = "0",
      className = "is-sticky",
    } = options;

    let originalPosition = "";
    let originalTop = "";
    let originalZIndex = "";
    let originalBackgroundColor = "";
    let originalPadding = "";
    let originalWidth = "";
    let originalLeft = "";
    let isSticky = false;
    let placeholder = null;
    let originalOffsetTop = 0;
    let headerElement = null;
    let currentTop = top;

    // Find header element
    const findHeader = () => {
      const header = document.querySelector(".section-header.header-visible");
      if (header) {
        headerElement = header;
        return header.offsetHeight;
      }
      return 0;
    };

    // Update top position based on header
    const updateTopPosition = () => {
      const headerHeight = findHeader();
      const newTop = headerHeight > 0 ? headerHeight : top;

      if (newTop !== currentTop) {
        currentTop = newTop;

        // Update sticky element position if it's currently sticky
        if (isSticky) {
          element.style.transition = "top .3s cubic-bezier(.4,0,.2,1)";
          element.style.top = `${currentTop}px`;
        }
      }
    };

    const updateStickyState = () => {
      // Update top position based on header
      updateTopPosition();

      if (!isSticky) {
        // When not sticky, check if we should become sticky
        const rect = element.getBoundingClientRect();
        const shouldBeSticky = rect.top <= currentTop;

        if (shouldBeSticky) {
          // Store original position for restoration
          originalOffsetTop = element.offsetTop;

          // Store original styles
          originalPosition = element.style.position;
          originalTop = element.style.top;
          originalZIndex = element.style.zIndex;
          originalBackgroundColor = element.style.backgroundColor;
          originalPadding = element.style.padding;
          originalWidth = element.style.width;
          originalLeft = element.style.left;

          // Create placeholder to maintain space
          placeholder = document.createElement("div");
          const computedStyle = window.getComputedStyle(element);

          // Copy all relevant styles to maintain exact spacing
          placeholder.style.height = `${rect.height}px`;
          placeholder.style.width = `${rect.width}px`;
          placeholder.style.margin = computedStyle.margin;
          placeholder.style.padding = computedStyle.padding;
          placeholder.style.border = computedStyle.border;
          placeholder.style.boxSizing = computedStyle.boxSizing;
          placeholder.style.visibility = "hidden";
          placeholder.style.pointerEvents = "none";
          placeholder.style.display = computedStyle.display;
          placeholder.style.flexDirection = computedStyle.flexDirection;
          placeholder.style.justifyContent = computedStyle.justifyContent;
          placeholder.style.alignItems = computedStyle.alignItems;
          placeholder.style.gap = computedStyle.gap;

          element.parentNode.insertBefore(placeholder, element);

          // Apply sticky styles
          element.style.position = "fixed";
          element.style.top = `${currentTop}px`;
          element.style.zIndex = zIndex;
          element.style.backgroundColor = backgroundColor;
          element.style.padding = padding;
          //element.style.width = "100vw";
          element.style.left = "0";
          element.style.right = "0";
          element.style.maxWidth = "none";
          element.style.boxShadow =
            "50px 0 0 0 " +
            backgroundColor +
            ", -50px 0 0 0 " +
            backgroundColor +
            ", -50px -20px 0 0 " +
            backgroundColor;
          ", -50px -20px 0 0 " + backgroundColor;
          element.style.transition = "top .3s cubic-bezier(.4,0,.2,1)";
          element.classList.add(className);

          isSticky = true;
        }
      } else {
        // When sticky, check if we should restore to normal
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const shouldRestore = scrollTop < originalOffsetTop - currentTop;

        if (shouldRestore) {
          // Remove placeholder
          if (placeholder && placeholder.parentNode) {
            placeholder.parentNode.removeChild(placeholder);
            placeholder = null;
          }

          // Restore original styles
          element.style.position = originalPosition;
          element.style.top = originalTop;
          element.style.zIndex = originalZIndex;
          element.style.backgroundColor = originalBackgroundColor;
          element.style.padding = originalPadding;
          element.style.width = originalWidth;
          element.style.left = originalLeft;
          element.style.right = "";
          element.style.maxWidth = "";
          element.style.boxShadow = "";
          element.style.marginLeft = "";
          element.style.marginRight = "";
          element.style.transition = "";
          element.classList.remove(className);

          isSticky = false;
        }
      }
    };

    // Initial check
    updateStickyState();

    // Set up resize observer for header changes
    let resizeObserver = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        updateStickyState();
      });

      // Observe the header element if it exists
      const header = document.querySelector(".section-header.header-visible");
      if (header) {
        resizeObserver.observe(header);
      } else {
        // Also observe any .section-header element in case it gets the header-visible class later
        const anyHeader = document.querySelector(".section-header");
        if (anyHeader) {
          resizeObserver.observe(anyHeader);
        }
      }
    }

    // Listen for scroll and resize events
    window.addEventListener("scroll", updateStickyState);
    window.addEventListener("resize", updateStickyState);

    // Return cleanup function
    return () => {
      window.removeEventListener("scroll", updateStickyState);
      window.removeEventListener("resize", updateStickyState);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }
    };
  },
  /**
   * Formats a price value by removing all decimal places
   * Handles both string and number inputs, with or without currency symbols
   * @param {string|number} price - The price to format
   * @returns {string} - The formatted price without decimal places
   */
  formatPriceWithoutDecimals(price) {
    if (!price && price !== 0) return "";

    if (typeof price === "number") {
      return Math.round(price).toString();
    }

    if (typeof price === "string") {
      // Remove all decimal places (e.g., "99.50" -> "99", "£199.99" -> "£199")
      return price.replace(/\.\d+/, "");
    }

    return String(price).replace(/\.\d+/, "");
  },
  /**
   * Formats a product price object (from Swym) by removing decimal places
   * Updates both pr (price) and op (original/compare price) properties
   * @param {Object} product - Product object with pr and/or op properties
   * @returns {Object} - The product object with formatted prices
   */
  formatProductPrice(product) {
    if (!product) return product;

    // Format price (pr)
    if (product.pr) {
      product.pr = this.formatPriceWithoutDecimals(product.pr);
    }

    // Format original/compare price (op)
    if (product.op) {
      product.op = this.formatPriceWithoutDecimals(product.op);
    }

    return product;
  },
};

window.ShopSuey = ShopSuey;

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1",
    );
}
